import $ from 'jquery';

$(function () {
    const $container = $('#deposit-calculator-app');
    if (!$container.length) return;

    // Default Fallback Chips
    const defaultChipsMap = {
        UAH: [10000, 50000, 100000, 250000, 500000],
        USD: [1000, 2500, 5000, 10000, 25000],
        EUR: [1000, 2500, 5000, 10000, 25000],
        PLN: [5000, 10000, 25000, 50000, 100000],
        GBP: [1000, 2000, 5000, 10000, 25000],
        CHF: [1000, 2500, 5000, 10000, 25000],
        CAD: [1000, 3000, 5000, 10000, 30000],
        CZK: [10000, 25000, 50000, 100000, 250000]
    };

    // Currency Presets Data
    const currencyPresets = {
        UAH: { symbol: '₴', code: 'UAH', amounts: defaultChipsMap.UAH, rates: [10.0, 12.0, 13.5, 15.0], defaultAmount: 50000, defaultRate: 13.5, defaultInflation: parseFloat($container.data('inflation-uah')) || 7.5, defaultTax: 23, maxAmount: 2000000, stepAmount: 5000, usdRate: 41.50, isQuickTab: true },
        USD: { symbol: '$', code: 'USD', amounts: defaultChipsMap.USD, rates: [1.5, 2.0, 2.5, 3.5], defaultAmount: 2500, defaultRate: 2.5, defaultInflation: parseFloat($container.data('inflation-usd')) || 2.9, defaultTax: 23, maxAmount: 200000, stepAmount: 500, usdRate: 1.0, isQuickTab: true },
        EUR: { symbol: '€', code: 'EUR', amounts: defaultChipsMap.EUR, rates: [1.0, 1.5, 2.0, 3.0], defaultAmount: 2500, defaultRate: 1.5, defaultInflation: parseFloat($container.data('inflation-eur')) || 2.2, defaultTax: 23, maxAmount: 200000, stepAmount: 500, usdRate: 0.92, isQuickTab: true },
        PLN: { symbol: 'zł', code: 'PLN', amounts: defaultChipsMap.PLN, rates: [4.0, 5.0, 6.0, 7.0], defaultAmount: 10000, defaultRate: 5.0, defaultInflation: 4.2, defaultTax: 19.0, maxAmount: 500000, stepAmount: 1000, usdRate: 3.97, isQuickTab: true }
    };

    // Populate from server JSON if available
    try {
        const rawCurrenciesJson = $('#deposit-available-currencies').text();
        if (rawCurrenciesJson) {
            const parsed = JSON.parse(rawCurrenciesJson);
            if (Array.isArray(parsed)) {
                parsed.forEach(c => {
                    const code = (c.Code || c.code || '').toUpperCase();
                    if (!code) return;
                    const chips = (c.AmountChips && c.AmountChips.length) ? c.AmountChips : (defaultChipsMap[code] || [1000, 5000, 10000, 25000, 50000]);
                    const defRate = c.DefaultRate || c.defaultRate || 5.0;
                    currencyPresets[code] = {
                        code: code,
                        symbol: c.Symbol || c.symbol || code,
                        name: c.Name || c.name || code,
                        amounts: chips,
                        rates: [defRate * 0.7, defRate * 0.9, defRate, defRate * 1.2].map(r => Math.round(r * 10) / 10),
                        defaultAmount: c.DefaultAmount || c.defaultAmount || 10000,
                        defaultRate: defRate,
                        defaultInflation: c.DefaultInflation || c.defaultInflation || 3.0,
                        defaultTax: c.DefaultTax ?? c.defaultTax ?? 23,
                        maxAmount: c.MaxAmount || c.maxAmount || 1000000,
                        stepAmount: c.StepAmount || c.stepAmount || 100,
                        usdRate: c.UsdRate || c.usdRate || 1.0,
                        isQuickTab: c.IsQuickTab ?? c.isQuickTab ?? true
                    };
                });
            }
        }
    } catch (e) {
        console.warn('Failed to parse #deposit-available-currencies JSON', e);
    }

    let currentCurrency = ($container.data('selected-currency') || 'UAH').toUpperCase();
    if (!currencyPresets[currentCurrency]) currentCurrency = 'UAH';

    // Elements
    const $currencyTabs = $('.deposit-currency-tab');
    const $currencyLabels = $('.deposit-currency-symbol');
    const $taxCurrencyBadge = $('#deposit-tax-currency-badge');
    const $inflationCurrencyBadge = $('#deposit-inflation-currency-badge');
    const $activeCustomCurrency = $('#deposit-active-custom-currency');
    const $moreCurrenciesBtn = $('#deposit-more-currencies-dropdown');

    const $amountInput = $('#deposit-amount-input');
    const $amountRange = $('#deposit-amount-range');
    const $amountChipsContainer = $('#deposit-amount-chips');

    const $rateInput = $('#deposit-rate-input');
    const $rateRange = $('#deposit-rate-range');
    const $rateChipsContainer = $('#deposit-rate-chips');

    const $termMonthsInput = $('#deposit-term-input');
    const $termChips = $('.deposit-term-chip');
    const $startDateInput = $('#deposit-start-date');
    const $maturityDateInput = $('#deposit-maturity-date');

    const $schemeBtns = $('.deposit-scheme-btn');
    let currentScheme = 'monthly_cap'; // 'maturity', 'monthly_cap', 'monthly_payout'

    const $taxesToggle = $('#deposit-taxes-toggle');
    const $taxRateInput = $('#deposit-tax-rate-input');
    const $taxCustomGroup = $('#deposit-tax-custom-group');

    const $topupToggle = $('#deposit-topup-toggle');
    const $topupGroup = $('#deposit-topup-group');
    const $topupInput = $('#deposit-topup-input');

    // KPI Stat Elements
    const $statNetProfit = $('#deposit-stat-net-profit');
    const $depositNetProfitLabel = $('#deposit-net-profit-label');
    const $depositNominalNote = $('#deposit-nominal-note');
    const $statGrossProfit = $('#deposit-stat-gross-profit');
    const $statTotalPayout = $('#deposit-stat-total-payout');
    const $statEffectiveRate = $('#deposit-stat-effective-rate');
    const $statTaxesPaid = $('#deposit-stat-taxes-paid');
    const $statMonthlyIncome = $('#deposit-stat-monthly-income');

    // FX Comparison Elements
    const $fxRow = $('#deposit-fx-row');
    const $fxCurrentRate = $('#deposit-fx-current-rate');
    const $fxDevalRange = $('#deposit-fx-deval-range');
    const $fxDevalInput = $('#deposit-fx-deval-input');
    const $fxProjectedRate = $('#deposit-fx-projected-rate');
    const $fxBreakevenRate = $('#deposit-fx-breakeven-rate');
    const $fxAdvantageBadge = $('#deposit-fx-advantage-badge');
    const $fxSpreadVal = $('#deposit-fx-spread-val');
    const $fxAlternativeUsd = $('#deposit-fx-alternative-usd');
    const $fxCurrencyAddon = $('#deposit-fx-currency-addon');
    const $fxRateLabel = $('#deposit-fx-rate-label');

    // Inflation Elements
    const $inflationToggle = $('#deposit-inflation-toggle');
    const $inflationCard = $('#deposit-inflation-card');
    const $inflationGroup = $('#deposit-inflation-group');
    const $inflationRateInput = $('#deposit-inflation-rate-input');
    const $statRealYield = $('#deposit-stat-real-yield');
    const $statRealProfit = $('#deposit-stat-real-profit');
    const $statInflationLoss = $('#deposit-stat-inflation-loss');
    const $capitalShieldBadge = $('#deposit-capital-shield-badge');
    const $progressPrincipal = $('#deposit-progress-principal');
    const $progressProfit = $('#deposit-progress-profit');
    const $progressDrag = $('#deposit-progress-drag');
    const $breakdownPrincipalVal = $('#deposit-breakdown-principal-val');
    const $breakdownProfitVal = $('#deposit-breakdown-profit-val');
    const $breakdownDragVal = $('#deposit-breakdown-drag-val');

    // OVDP Comparison Elements
    const $ovdpRow = $('#deposit-ovdp-row');
    const $ovdpTaxLoss = $('#deposit-ovdp-tax-loss');
    const $ovdpCtaLink = $('#deposit-ovdp-cta-link');

    // Schedule Elements
    const $scheduleBody = $('#deposit-schedule-body');

    // Localized Strings from Data Attributes
    const textDays = $container.data('text-days') || 'days';
    const textMonths = $container.data('text-months') || 'months';
    const textProtected = $container.data('text-shield-protected') || 'Capital Protected';
    const textEroded = $container.data('text-shield-eroded') || 'Capital Eroded';
    const textDepositWins = $container.data('text-fx-deposit-wins') || 'Deposit is more profitable';
    const textUsdWins = $container.data('text-fx-usd-wins') || 'Buying USD is more profitable';
    const textNetProfit = $container.data('text-net-profit') || 'Net profit';
    const textRealNetProfit = $container.data('text-real-net-profit') || 'Real net profit (with inflation)';
    const textNominalNote = $container.data('text-nominal-note') || 'Nominal profit: {0} | Inflation loss: {1}';
    const textRealRateBadge = $container.data('text-real-rate-badge') || '{0}% real p.a.';
    const textThousands = $container.data('text-thousands') || 'k';
    const textMoreCurrencies = $container.data('text-more-currencies') || 'More';
    const textMoreShort = $container.data('text-more-short') || textMoreCurrencies;
    const textFxRateLabel = $container.data('text-fx-rate-label') || 'USD/{0} rate';

    // Formatting Helpers
    function formatMoney(amount, currencyCode = currentCurrency, includeSymbol = true) {
        if (isNaN(amount)) amount = 0;
        const config = currencyPresets[currencyCode] || currencyPresets.UAH;
        const formatted = Math.round(amount).toLocaleString('uk-UA').replace(/\u00A0/g, ' ');
        return includeSymbol ? `${formatted} ${config.symbol}` : formatted;
    }

    function formatPercent(pct, decimals = 2) {
        if (isNaN(pct)) pct = 0;
        return `${pct.toFixed(decimals)}%`;
    }

    // Set Dates
    function initDates() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        $startDateInput.val(`${yyyy}-${mm}-${dd}`);
        syncMaturityDate();
    }

    function syncMaturityDate() {
        const startVal = $startDateInput.val();
        const months = parseInt($termMonthsInput.val(), 10) || 12;
        const startDate = startVal ? new Date(startVal) : new Date();

        const maturityDate = new Date(startDate);
        maturityDate.setMonth(maturityDate.getMonth() + months);

        const yyyy = maturityDate.getFullYear();
        const mm = String(maturityDate.getMonth() + 1).padStart(2, '0');
        const dd = String(maturityDate.getDate()).padStart(2, '0');
        $maturityDateInput.val(`${yyyy}-${mm}-${dd}`);
    }

    // Dynamic Render of Preset Chips
    function renderAmountChips() {
        const config = currencyPresets[currentCurrency];
        $amountChipsContainer.empty();
        config.amounts.forEach(amt => {
            const label = amt >= 1000 ? `${amt / 1000} ${textThousands} ${config.symbol}` : `${amt} ${config.symbol}`;
            const $chip = $(`<button type="button" class="deposit-preset-chip deposit-amount-chip" data-amount="${amt}">${label}</button>`);
            $amountChipsContainer.append($chip);
        });
        syncAmountChipActive();
    }

    function renderRateChips() {
        const config = currencyPresets[currentCurrency];
        $rateChipsContainer.empty();
        config.rates.forEach(r => {
            const $chip = $(`<button type="button" class="deposit-preset-chip deposit-rate-chip" data-rate="${r}">${r}%</button>`);
            $rateChipsContainer.append($chip);
        });
        syncRateChipActive();
    }

    function syncAmountChipActive() {
        const currentVal = parseFloat($amountInput.val()) || 0;
        $('.deposit-amount-chip').each(function () {
            const chipAmt = parseFloat($(this).data('amount'));
            $(this).toggleClass('active', Math.abs(chipAmt - currentVal) < 1);
        });
    }

    function syncRateChipActive() {
        const currentVal = parseFloat($rateInput.val()) || 0;
        $('.deposit-rate-chip').each(function () {
            const chipRate = parseFloat($(this).data('rate'));
            $(this).toggleClass('active', Math.abs(chipRate - currentVal) < 0.05);
        });
    }

    function syncTermChipActive() {
        const currentVal = parseInt($termMonthsInput.val(), 10) || 12;
        $termChips.each(function () {
            const chipTerm = parseInt($(this).data('months'), 10);
            $(this).toggleClass('active', chipTerm === currentVal);
        });
    }

    // Switch Currency
    function switchCurrency(newCurr) {
        if (!currencyPresets[newCurr]) return;
        currentCurrency = newCurr;

        const config = currencyPresets[newCurr];

        $currencyTabs.removeClass('active');
        $(`.deposit-currency-tab[data-currency="${newCurr}"]`).addClass('active');

        // Manage Dropdown state vs Quick tabs
        if (config.isQuickTab) {
            $moreCurrenciesBtn.removeClass('active');
            $activeCustomCurrency.html(`<span class="d-none d-sm-inline">${textMoreCurrencies}</span><span class="d-sm-none">${textMoreShort}</span>`);
        } else {
            $moreCurrenciesBtn.addClass('active');
            $activeCustomCurrency.text(`${config.symbol} ${config.code}`);
        }

        $currencyLabels.text(config.symbol);
        $taxCurrencyBadge.text(newCurr);
        $inflationCurrencyBadge.text(newCurr);

        $amountInput.attr('max', config.maxAmount).attr('step', config.stepAmount).val(config.defaultAmount);
        $amountRange.attr('max', config.maxAmount).attr('step', config.stepAmount).val(config.defaultAmount);

        $rateInput.val(config.defaultRate);
        $rateRange.val(config.defaultRate);
        $('#deposit-rate-display').text(config.defaultRate.toFixed(1) + '%');

        $inflationRateInput.val(config.defaultInflation);
        $taxRateInput.val(config.defaultTax);

        renderAmountChips();
        renderRateChips();

        // Show/hide FX comparison (relevant for any currency except USD)
        if (newCurr !== 'USD') {
            $fxRow.show();
            if (config.usdRate) {
                const formattedRate = config.usdRate >= 10 ? config.usdRate.toFixed(2) : config.usdRate.toFixed(4);
                $fxCurrentRate.val(formattedRate);
            }
            if ($fxCurrencyAddon.length) {
                $fxCurrencyAddon.text(config.symbol);
            }
            if ($fxRateLabel.length) {
                $fxRateLabel.text(textFxRateLabel.replace('{0}', newCurr));
            }
        } else {
            $fxRow.hide();
        }

        // OVDP is specifically relevant for UAH
        if (newCurr === 'UAH') {
            $ovdpRow.show();
        } else {
            $ovdpRow.hide();
        }

        recalculate();
    }

    // Core Calculation Engine
    function recalculate() {
        const principal = parseFloat($amountInput.val()) || 0;
        const annualRate = parseFloat($rateInput.val()) || 0;
        const months = parseInt($termMonthsInput.val(), 10) || 12;
        
        const hasTaxes = $taxesToggle.is(':checked');
        $taxRateInput.prop('disabled', !hasTaxes);
        const taxRatePct = hasTaxes ? (parseFloat($taxRateInput.val()) || 0) : 0;
        const taxRate = taxRatePct / 100;

        const hasInflation = $inflationToggle.is(':checked');
        $inflationRateInput.prop('disabled', !hasInflation);
        if (hasInflation) {
            $inflationCard.show();
        } else {
            $inflationCard.hide();
        }

        const hasTopup = $topupToggle.is(':checked');
        const topupAmount = hasTopup ? (parseFloat($topupInput.val()) || 0) : 0;

        const startDateVal = $startDateInput.val();
        let currDate = startDateVal ? new Date(startDateVal) : new Date();

        let activeDepositPrincipal = principal;
        let cumulativeCapital = principal;
        let totalGrossInterest = 0;
        let totalTaxWithheld = 0;
        let totalNetInterest = 0;

        const schedule = [];

        // Month-by-month calculation
        for (let m = 1; m <= months; m++) {
            let startMonthBalance;
            let monthGrossInterest;

            if (currentScheme === 'monthly_cap') {
                startMonthBalance = cumulativeCapital;
                monthGrossInterest = startMonthBalance * (annualRate / 100 / 12);
            } else {
                // In maturity or monthly_payout, simple interest is calculated on active invested principal
                startMonthBalance = currentScheme === 'maturity' ? cumulativeCapital : activeDepositPrincipal;
                monthGrossInterest = activeDepositPrincipal * (annualRate / 100 / 12);
            }

            const monthTax = monthGrossInterest * taxRate;
            const monthNetInterest = monthGrossInterest - monthTax;

            totalGrossInterest += monthGrossInterest;
            totalTaxWithheld += monthTax;
            totalNetInterest += monthNetInterest;

            let endBalance;
            if (currentScheme === 'monthly_cap') {
                cumulativeCapital = startMonthBalance + monthNetInterest + topupAmount;
                endBalance = cumulativeCapital;
            } else if (currentScheme === 'maturity') {
                // In maturity scheme, interest accumulates with capital until the final payout
                cumulativeCapital = startMonthBalance + topupAmount + monthNetInterest;
                activeDepositPrincipal += topupAmount;
                endBalance = cumulativeCapital;
            } else {
                // In monthly_payout, interest is paid out monthly, deposit body remains
                activeDepositPrincipal += topupAmount;
                endBalance = activeDepositPrincipal;
            }

            // Next date
            const rowDate = new Date(currDate);
            rowDate.setMonth(rowDate.getMonth() + m);
            const dateStr = `${rowDate.getFullYear()}-${String(rowDate.getMonth() + 1).padStart(2, '0')}-${String(rowDate.getDate()).padStart(2, '0')}`;

            schedule.push({
                month: m,
                date: dateStr,
                startBalance: startMonthBalance,
                topup: topupAmount,
                grossInterest: monthGrossInterest,
                tax: monthTax,
                netInterest: monthNetInterest,
                endBalance: endBalance
            });
        }

        const totalInvested = principal + (topupAmount * months);
        const finalPayout = currentScheme === 'monthly_payout' ? (totalInvested + totalNetInterest) : cumulativeCapital;
        const avgMonthlyIncome = totalNetInterest / Math.max(1, months);

        // Effective Annual Yield (APY)
        let effectiveRate = 0;
        if (totalInvested > 0 && months > 0) {
            const annualizedYield = (totalNetInterest / totalInvested) * (12 / months);
            effectiveRate = annualizedYield * 100;
        }

        // Inflation Calculations (Fisher equation & discounted purchasing power)
        const inflationRate = parseFloat($inflationRateInput.val()) || 0;
        const inflDecimal = inflationRate / 100;
        const yieldDecimal = effectiveRate / 100;
        const realYieldRate = ((1 + yieldDecimal) / (1 + inflDecimal) - 1) * 100;
        const timeYears = months / 12;
        const realPurchasingPower = inflDecimal > 0 ? (finalPayout / Math.pow(1 + inflDecimal, timeYears)) : finalPayout;
        const realNetProfit = realPurchasingPower - totalInvested;
        const inflationDrag = Math.max(0, finalPayout - realPurchasingPower);

        // Render Primary KPIs based on inflation toggle
        if (hasInflation) {
            $depositNetProfitLabel.text(textRealNetProfit);
            $statNetProfit.text((realNetProfit >= 0 ? '+' : '') + formatMoney(realNetProfit));
            $statEffectiveRate.text(textRealRateBadge.replace('{0}', (realYieldRate >= 0 ? '+' : '') + realYieldRate.toFixed(1)));
            const noteText = textNominalNote
                .replace('{0}', formatMoney(totalNetInterest))
                .replace('{1}', `-${formatMoney(inflationDrag)}`);
            $depositNominalNote.text(noteText).show();
        } else {
            $depositNetProfitLabel.text(textNetProfit);
            $statNetProfit.text(formatMoney(totalNetInterest));
            $statEffectiveRate.text(formatPercent(effectiveRate) + ' APY');
            $depositNominalNote.hide();
        }

        $statGrossProfit.text(formatMoney(totalGrossInterest));
        $statTotalPayout.text(formatMoney(finalPayout));
        $statTaxesPaid.text(formatMoney(totalTaxWithheld));
        $statMonthlyIncome.text(formatMoney(avgMonthlyIncome));

        // Render OVDP Tax Advantage
        if (currentCurrency === 'UAH') {
            $ovdpTaxLoss.text(formatMoney(totalTaxWithheld));
            $ovdpCtaLink.attr('href', `/bonds/ovdp?currency=UAH`);
        }

        // FX Devaluation & USD Comparison
        calculateFxScenario(principal, totalNetInterest, finalPayout, months);

        // Inflation & Real Return Analytics Card
        calculateInflationScenario(totalInvested, totalNetInterest, finalPayout, realYieldRate, realNetProfit, inflationDrag);

        // Render Schedule Table
        renderScheduleTable(schedule, totalInvested, totalNetInterest, finalPayout, months);
    }

    // USD Devaluation Comparison
    function calculateFxScenario(principal, netProfitLocal, finalPayoutLocal, months) {
        if (currentCurrency === 'USD') return;

        const config = currencyPresets[currentCurrency] || currencyPresets.UAH;
        const currentRate = parseFloat($fxCurrentRate.val()) || config.usdRate || 1.0;
        const devalPct = parseFloat($fxDevalInput.val()) || 0;
        const projectedRate = currentRate * (1 + devalPct / 100);
        $fxProjectedRate.text(projectedRate >= 10 ? projectedRate.toFixed(2) : projectedRate.toFixed(4));

        // Alternative: Buy USD initially with deposit principal
        const usdPurchased = currentRate > 0 ? (principal / currentRate) : 0;
        $fxAlternativeUsd.text(`$${Math.round(usdPurchased).toLocaleString('uk-UA')}`);

        // Alternative USD deposit yield benchmark (e.g. 2.5% gross with 23% tax => 1.93% net)
        const usdNetRate = (2.5 * (1 - 0.195)) / 100;
        const usdEarnedInterest = usdPurchased * usdNetRate * (months / 12);
        const totalUsdAtMaturity = usdPurchased + usdEarnedInterest;

        // Value of USD in local currency at projected exit rate
        const totalLocalFromUsd = totalUsdAtMaturity * projectedRate;
        const localDifference = finalPayoutLocal - totalLocalFromUsd;

        // Breakeven Rate: S_breakeven = finalPayoutLocal / totalUsdAtMaturity
        const breakevenRate = totalUsdAtMaturity > 0 ? (finalPayoutLocal / totalUsdAtMaturity) : currentRate;
        const formattedBreakeven = breakevenRate >= 10 ? breakevenRate.toFixed(2) : breakevenRate.toFixed(4);
        $fxBreakevenRate.text(`${formattedBreakeven} ${config.symbol}`);

        // Badge & Spread
        if (localDifference >= 0) {
            $fxAdvantageBadge
                .removeClass('bg-danger text-danger bg-soft-danger')
                .addClass('bg-soft-success text-success')
                .html(`<i class="bx bx-trending-up me-1"></i>${textDepositWins}`);
            $fxSpreadVal.text(`+${formatMoney(localDifference)}`);
        } else {
            $fxAdvantageBadge
                .removeClass('bg-success text-success bg-soft-success')
                .addClass('bg-soft-danger text-danger')
                .html(`<i class="bx bx-trending-down me-1"></i>${textUsdWins}`);
            $fxSpreadVal.text(`${formatMoney(localDifference)}`);
        }
    }

    // Inflation & Real Yield Breakdown Card
    function calculateInflationScenario(totalInvested, netProfit, finalPayout, realYieldRate, realNetProfit, inflationDrag) {
        $statRealYield.text(formatPercent(realYieldRate));
        $statRealProfit.text(formatMoney(realNetProfit));
        $statInflationLoss.text(formatMoney(inflationDrag));

        // Capital Protection Badge
        if (realYieldRate >= 0) {
            $capitalShieldBadge
                .removeClass('bg-soft-danger text-danger')
                .addClass('bg-soft-success text-success')
                .html(`<i class="bx bx-shield-quarter me-1"></i>${textProtected}`);
        } else {
            $capitalShieldBadge
                .removeClass('bg-soft-success text-success')
                .addClass('bg-soft-danger text-danger')
                .html(`<i class="bx bx-shield-alt-2 me-1"></i>${textEroded}`);
        }

        // Stacked Breakdown Bar
        const barTotal = Math.max(1, finalPayout);
        const pctPrincipal = Math.min(100, (totalInvested / barTotal) * 100);
        const pctProfit = Math.min(100, Math.max(0, (netProfit / barTotal) * 100));
        const pctDrag = Math.min(100, (inflationDrag / barTotal) * 100);

        $progressPrincipal.css('width', `${pctPrincipal}%`);
        $progressProfit.css('width', `${pctProfit}%`);
        $progressDrag.css('width', `${pctDrag}%`);

        $breakdownPrincipalVal.text(formatMoney(totalInvested));
        $breakdownProfitVal.text(formatMoney(netProfit));
        $breakdownDragVal.text(formatMoney(inflationDrag));
    }

    // Schedule Table Generation
    function renderScheduleTable(schedule, totalInvested, totalNetInterest, finalPayout, totalMonths) {
        $scheduleBody.empty();
        if (!schedule.length) return;

        schedule.forEach(row => {
            const isLastMonth = row.month === totalMonths;
            const tr = `
                <tr>
                    <td class="text-center font-size-12 fw-semibold">${row.month}</td>
                    <td class="text-muted font-size-12">${row.date}</td>
                    <td class="text-end font-size-12 text-nowrap d-none d-sm-table-cell">${formatMoney(row.startBalance)}</td>
                    <td class="text-end font-size-12 text-nowrap text-success fw-medium">+${formatMoney(row.netInterest)}</td>
                    <td class="text-end font-size-12 text-nowrap fw-bold ${isLastMonth ? 'text-primary' : ''}">${formatMoney(row.endBalance)}</td>
                </tr>
            `;
            $scheduleBody.append(tr);
        });

        const $scheduleFoot = $('#deposit-schedule-foot');
        if ($scheduleFoot.length && totalInvested !== undefined) {
            $scheduleFoot.empty();
            const footHtml = `
                <tr class="fw-bold bg-light">
                    <td class="text-center font-size-12">Σ</td>
                    <td class="font-size-12 text-muted">${totalMonths} ${textMonths}</td>
                    <td class="text-end font-size-12 text-nowrap d-none d-sm-table-cell">${formatMoney(totalInvested)}</td>
                    <td class="text-end font-size-12 text-nowrap text-success">+${formatMoney(totalNetInterest)}</td>
                    <td class="text-end font-size-12 text-nowrap text-primary font-size-13">${formatMoney(finalPayout)}</td>
                </tr>
            `;
            $scheduleFoot.html(footHtml);
        }
    }

    // Event Handlers

    // 1. Currency tabs & dropdown items
    $(document).on('click', '.deposit-currency-tab', function (e) {
        e.preventDefault();
        const sel = $(this).data('currency');
        if (sel) switchCurrency(sel);
    });

    // 2. Amount Input & Slider & Chips
    $amountInput.on('input', function () {
        const val = parseFloat($(this).val()) || 0;
        $amountRange.val(val);
        syncAmountChipActive();
        recalculate();
    });

    $amountRange.on('input', function () {
        const val = parseFloat($(this).val()) || 0;
        $amountInput.val(val);
        syncAmountChipActive();
        recalculate();
    });

    $(document).on('click', '.deposit-amount-chip', function () {
        const amt = parseFloat($(this).data('amount'));
        $amountInput.val(amt);
        $amountRange.val(amt);
        syncAmountChipActive();
        recalculate();
    });

    // 3. Rate Input & Slider & Chips
    $rateInput.on('input', function () {
        const val = parseFloat($(this).val()) || 0;
        $rateRange.val(val);
        $('#deposit-rate-display').text(val.toFixed(1) + '%');
        syncRateChipActive();
        recalculate();
    });

    $rateRange.on('input', function () {
        const val = parseFloat($(this).val()) || 0;
        $rateInput.val(val);
        $('#deposit-rate-display').text(val.toFixed(1) + '%');
        syncRateChipActive();
        recalculate();
    });

    $(document).on('click', '.deposit-rate-chip', function () {
        const r = parseFloat($(this).data('rate'));
        $rateInput.val(r);
        $rateRange.val(r);
        $('#deposit-rate-display').text(r.toFixed(1) + '%');
        syncRateChipActive();
        recalculate();
    });

    // 4. Term Input & Chips
    $termMonthsInput.on('input', function () {
        syncTermChipActive();
        syncMaturityDate();
        recalculate();
    });

    $termChips.on('click', function () {
        const m = parseInt($(this).data('months'), 10);
        $termMonthsInput.val(m);
        syncTermChipActive();
        syncMaturityDate();
        recalculate();
    });

    $startDateInput.on('change', function () {
        syncMaturityDate();
        recalculate();
    });

    // 5. Payment Scheme
    $schemeBtns.on('click', function () {
        $schemeBtns.removeClass('active');
        $(this).addClass('active');
        currentScheme = $(this).data('scheme');
        recalculate();
    });

    // 6. Taxes Toggle & Custom Input
    $taxesToggle.on('change', function () {
        recalculate();
    });

    $taxRateInput.on('input', function () {
        recalculate();
    });

    // 7. Top-up Toggle & Input
    $topupToggle.on('change', function () {
        if ($(this).is(':checked')) {
            $topupGroup.show();
        } else {
            $topupGroup.hide();
        }
        recalculate();
    });

    $topupInput.on('input', function () {
        recalculate();
    });

    // 8. FX Devaluation Slider & Input
    $fxDevalRange.on('input', function () {
        const val = parseFloat($(this).val()) || 0;
        $fxDevalInput.val(val);
        $('#deposit-fx-deval-val').text(val);
        recalculate();
    });

    $fxDevalInput.on('input', function () {
        const val = parseFloat($(this).val()) || 0;
        $fxDevalRange.val(val);
        $('#deposit-fx-deval-val').text(val);
        recalculate();
    });

    $fxCurrentRate.on('input', function () {
        recalculate();
    });

    // 9. Inflation Toggle & Input
    $inflationToggle.on('change', function () {
        recalculate();
    });

    $inflationRateInput.on('input', function () {
        recalculate();
    });

    // Initialize Page
    initDates();
    renderAmountChips();
    renderRateChips();
    syncTermChipActive();
    switchCurrency(currentCurrency);

    // Mode-specific initialization
    const calcMode = String($container.data('calculator-mode') || 'standard').toLowerCase();
    if (calcMode === 'compound') {
        const $capBtn = $schemeBtns.filter('[data-scheme="monthly_cap"]');
        if ($capBtn.length) {
            $schemeBtns.removeClass('active');
            $capBtn.addClass('active');
            currentScheme = 'monthly_cap';
        }
        if (!$topupToggle.is(':checked')) {
            $topupToggle.prop('checked', true).trigger('change');
            if (!parseFloat($topupInput.val())) {
                $topupInput.val(5000);
            }
        }
        recalculate();
    } else if (calcMode === 'tax_inflation') {
        if (!$inflationToggle.is(':checked')) {
            $inflationToggle.prop('checked', true).trigger('change');
        }
        if (!$taxesToggle.is(':checked')) {
            $taxesToggle.prop('checked', true).trigger('change');
        }
        recalculate();
    }
});

